<template lang="pug">
.side_menu
  .side_menu_block(v-for="item in menuData" :key="item.name")
    router-link.side_menu_item(:to="item.url" @click.native="$emit('close')") {{ item.name }}
      router-link(v-for="item2 in item.sub" :to="item2.url" :key="item2.name")
        .side_menu_second {{ item2.name }}
  .side_menu_close_button(@click="$emit('close')")
</template>

<script>
export default {
  data() {
    return {
      menuData: null,
      navbarArray: [

        {
          name: '法規與政策',
          url: '/list/1',
        },
        {
          name: '美感計畫',
          url: '/project/1',
        },
        {
          name: '成果專區',
          url: '/section/178/category/122'
        },
        {
          name: '教學資源',
          url: '/teach',
        },
        {
          name: '文化美感輕旅行',
          url: '/activity/school',
        },
        {
          name: '藝拍即合',
          url: '#',
          sub: [
            // {
            //   name: '一般活動',
            //   url: '/activity/normal'
            // },
            {
              name: '找補助',
              url: '/artedu1872/subsidy'
            },
            {
              name: '體驗課程',
              url: '/artedu1872/class'
            },
          ]
        },
        {
          name: '縣市填報',
           url: '/activity/results',
        },
        {
          name: '網網相連',
          url: '/link/1',
        },
      ],
    }
  },
  created() {
    this.getMenu();
  },
  methods: {
    getMenu() {
      this.menuData = this.navbarArray
    },
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'
.side_menu
  // +bb
  background-color: rgba(#333, 0.8)
  position: fixed
  z-index: 30
  height: 100vh
  width: 500px
  box-sizing: border-box
  padding: 50px 0 0 0
  // transform: translateX(-100%)
  // +pad
  //   display: none
  +phone
    width: 90%

  .side_menu_block
    width: 100%
    +flexcolumn
    // justify-content: center
    align-items: center
    // padding: 50px 0 0 0
    .side_menu_item
      width: max-content
      color: #fff
      font-size: 20px
      letter-spacing: 1.5px
      font-weight: bold
      margin-bottom: 20px
      +com
        font-size: 15px
      .side_menu_second
        color: #fff
        font-weight: 300
        font-size: 15px
        margin-top: 10px
        +com
          font-size: 12px
  .side_menu_close_button
    position: absolute
    top: 15px
    right: 15px
    background: url('../assets/side_menu_close.png')
    width: 15px
    height: 15px
    opacity: 0.8
    +bgcon
    cursor: pointer
    transition: 0.1s
    transform-origin: 50%
    &:hover
      transform: scale(1.1)
      transition: 0.1s
      transform-origin: 50%




</style>



// WEBPACK FOOTER //
// src/components/side_menu.vue